import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=be1ff5be&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=be1ff5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1ff5be",
  null
  
)

export default component.exports